import React, { useState } from "react";
import { Card } from "@material-ui/core";
import ContextualMenu from "../contextualMenu";
import BlockUser from "../blockUser";
import { dispatch } from "../../events";
import { types } from "../../events/loader";
import { types as userTypes } from "../../events/user";
import { types as messagTypes } from "../../events/message";
import httpUtils from "../../utils/http.utils";
import config from "../../config";

const UserCard = ({ user }) => {
    const [openBlockUserModal, setOpenBlockUserModal] = useState(false);
    const getMenu = () => [
        { key: 'block', title: 'Block user', action: () => setOpenBlockUserModal(true), show: true },
        { key: 'deleteReport', title: 'Delete reports', action: deleteReports, show: user.reported }
    ]

    const deleteReports = async () => {
        dispatch(types.SET_LOADER);
        await httpUtils.delete(`${config.BACK_API}/api/user/${user.id}/reports`);
        dispatch(types.UNSET_LOADER);
        dispatch(userTypes.DELETE_USER_REPORTS, { user });
    }

    const onClickData = (event, key) => {
        event.stopPropagation();
        navigator.clipboard.writeText(user[key])
            .then(() => {
                dispatch(messagTypes.SET_MESSAGE, `User ${key} copied to clipboard`);
            });
    }

    return (
        <Card>
            <ContextualMenu elements={getMenu()} />
            {Object.keys(user).map((key) => (
                <p key={key} onClick={(event) => onClickData(event, key)}>{key} : {user[key]}</p>
            ))}
            {openBlockUserModal && <BlockUser user={user} onClose={() => setOpenBlockUserModal(false)} />}
        </Card>
    );
}

export default UserCard;